import { render, staticRenderFns } from "./SeatTable.vue?vue&type=template&id=8c67216e&scoped=true"
import script from "./SeatTable.vue?vue&type=script&lang=ts"
export * from "./SeatTable.vue?vue&type=script&lang=ts"
import style0 from "./SeatTable.vue?vue&type=style&index=0&id=8c67216e&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c67216e",
  null
  
)

export default component.exports